<div class="app" (click)="redirect()">
  <div class="__wrap">
    <div class="__screen">
      <div class="_wrap">
        <div class="swiper slider">
          <div class="swiper-wrapper">
            <!-- <div class="swiper-slide">&nbsp;</div>  -->
            <div class="swiper-slide">
              <img
                src="{{helperData.SLIDE1}}"
                alt="slide"
                class="s1 img-fluid"
              />
              <img
                src="{{helperData.SLIDE2}}"
                alt="slide"
                class="s2 img-fluid ex" [ngClass]="{'s2flipkart': helperData.BRAND_NAME=='flipkart', 's2amazon':helperData.BRAND_NAME=='Amazon' }"
              />
            </div>
            <div class="swiper-slide">
              <img
                src="{{helperData.SLIDE3}}"
                alt="slide"
                class="s3 img-fluid"
              />
             <img
                src="{{helperData.SLIDE4}}"
                alt="slide"
                class="s4 img-fluid ex" [ngClass]="{'s4flipkart': helperData.BRAND_NAME=='flipkart', 's4amazon':helperData.BRAND_NAME=='Amazon' }"
              />
            </div>
          </div>
          <div class="swiper-pagination" id="pagination-swiper"></div>
        </div>
      </div>
    </div>
    <div class="__details">
      <div class="_wrap">
        <div class="_box">
          <div class="box_wrap">
            <div class="_icon">
              <img
                src="./assets/helperscreen/hand.gif"
                alt="hand"
                class="img-fluid"
              />
            </div>
            <div class="_badge">
              <span
                >Choose <span>TVS Credit</span> from
                <span>EMI (Easy Installments)</span></span
              >
            </div>
            <p>and enjoy seamless shopping</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>